/**********************************************************************
// @@@ START COPYRIGHT @@@
//
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/

import { Api } from '@/services/Api'
import axios from 'axios'
import store from "@/store/index"
const momentTz = require('moment-timezone')

export default {
  fetchTemplate(plantId, plantName) {
    Api().request({
      url: `/api/v2/zmu/admin/fetch/${plantId}`, // your url
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      const tz = store.getters.getActivePlantInfo('timezone')
      link.href = url
      link.setAttribute('download', `${plantName}_multiplication_factor-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`) // or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  },
  zmuCacheRefresh(reset) {
    return axios.post('https://m2m.eaglesunscada.com/api/v1.0/pushzmu/resetzmuconfig', reset)
  }
}
